import { OccasionalTransportMode } from 'app/constants/configuration/occasionalTransportMode'

export const getOccasionalTransportModeName = (
  occasionalTransportMode: OccasionalTransportMode,
  translate: (string) => string,
): string => {
  const text: string = OccasionalTransportMode[occasionalTransportMode]
  return translate(`occasionalTransportMode.${text}`)
}
